// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btns[data-v-a7d82bf8]{display:flex;flex-direction:row;justify-content:space-between}.ok-btn[data-v-a7d82bf8]{color:red;text-decoration:underline;line-height:2.5rem;cursor:pointer}.cancel-btn[data-v-a7d82bf8]{padding:.5em 1em;background-color:#d5eae7;color:#35907f;border:2px solid #0ec5a4;border-radius:5px;font-weight:700;font-size:16px;text-transform:uppercase;cursor:pointer}", ""]);
// Exports
module.exports = exports;
